import Visit from "./Visit";

export default Visit;
